import { PLAYER_LICENSE } from './player-license';

export const environment = {
  production: false,
  localDev: false,
  env_name: 'stag',
  accountId: '561405691527',

  castlabs_idp_issuer: 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_Yuu8o8Ilg',
  castlabs_idp_app_client_id: '2o4rt792ffknurp5qb5uv46s3h',
  castlabs_idp_logout_url: 'https://login.test.cs.castlabs.com/logout?client_id={{client_id}}&logout_uri=\' + window.location.origin + \'/',
  castlabs_idp_api_base:  'https://auth.test.cs.castlabs.com/api/v1',
  castlabs_idp_mfa_setup: 'https://account.test.cs.castlabs.com/account',

  above_idp_issuer: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_NdTjueRpE',
  above_idp_app_client_id: '3tu1fdceo0dff13umce21f9ab9',
  // Trades the above id_token for the CS token the backends are called with (ApiTokenService).
  federate_url: 'https://federate.content-stag.castlabs.com/',

  uploaderurl: 'https://up.content-stag.castlabs.com',

  VTK: 'https://fe.vtks.castlabs.com',
  VTK_API: 'https://api.vtks.castlabs.com',
  Portal: 'https://portal.content-stag.castlabs.com',

  region: 'us-east-1',
  graphql: 'https://repository.content-stag.castlabs.com/graphql',
  workflow_graphql: 'https://workflow.content-stag.castlabs.com/graphql',
  status_graphql: 'https://status.content-stag.castlabs.com/graphql',
  signiant_graphql: 'https://rx-signiant.content-stag.castlabs.com/graphql',
  aspera_graphql: 'https://aspera.content-stag.castlabs.com/graphql',
  crd_signal_server: 'https://crd-signal.content-stag.castlabs.com',

  // Shared across all environments -- see ./player-license.ts
  player_license: PLAYER_LICENSE,

  title: 'Castlabs Content Platform (stag)',


  poitems_table: 'workflow-stag-POItems-1F1IRJX94W2O5',

  redirects : {
    'above_above': 'urn:janus:organization:0a46318f20c445a19f9ecc7853f86d90',
    'above_touch': 'urn:janus:organization:3b74f8613e8c4169a933f3047f3351de',
    'castlabs': 'urn:janus:organization:9fa73f786f62470c838995d019f2c393'
  }

};
